import styled, { css } from 'styled-components';

export const TimePickerStyles = css`
  hot-input-group .hot-input-group__prepend:not(button):not(hot-dropdown) {
    order: 1 !important;
    border: none !important;
    background-color: transparent !important;
  }

  :host .hot-input-group__prepend::before {
    background-image: initial !important;
    height: 1.5rem;
    width: 1.5rem;
  }

  input#time-picker-input {
    order: 0 !important;
    background: transparent !important;
    border: none !important;
  }

  .flatpickr-calendar.open {
    border-color: var(--gray-200) !important;
    background: transparent !important;
  }
`;

export const TimePickerBox = styled.div`
  border-color: var(--input-border-color);
  border-style: solid;
  border-width: var(--input-border-width, 0.0625rem);
  border-radius: var(--input-border-radius) !important;

  & .icon-box {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
`